import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import ApiConstants from "../../../api-constants";
import { CompetitionMaster } from "../../../Types/CompetitionMaster";
import Constants from "../../../constants";

const fetchCompetitionMaster = async (competitionId: string) => {
  const res = await axios.get(ApiConstants.competitionMaster, {
    headers: {
      Authorization: ApiConstants.authToken,
      "X-Parse-Application-Id": ApiConstants.parseApplicationId,
      "X-Parse-Client-Key": ApiConstants.parseClientKey,
      "X-Parse-Master-Key": ApiConstants.parseMasterKey,
    },
    params: {
      include: "tees,secretHoles",
      where: {
        objectId: competitionId,
      },
    },
  });

  if (res.status === 200) {
    return res.data.results[0];
  } else {
    throw new AxiosError(`Unexpected status code: ${res.status}`);
  }
};

function useCompetitionMaster(competitionId: string) {
  const {
    data: competitionMaster,
    error,
    isLoading,
  } = useQuery<CompetitionMaster, AxiosError>(
    ["competitionMaster", competitionId],
    () => fetchCompetitionMaster(competitionId),
    {
      enabled: Boolean(competitionId), // Fetch only if competitionId exists
      refetchInterval: Constants.refreshTime, // Refetch every 20 seconds
      refetchOnWindowFocus: false, // Optional: Avoid refetching on window focus
    }
  );

  return {
    competitionMaster,
    error,
    isLoading, // `isLoading` will only be true for the initial fetch
  };
}

export default useCompetitionMaster;
